// === CSS
import '../../../sass/components/woocommerce/product-surface-calculator.scss'

document.addEventListener('DOMContentLoaded', () => {
  const quantityInputEl = document.querySelector('.product-summary .qty')
  const surfaceInputEl = document.querySelector('.surface-calculator [type="number"]')
  const cuttingLossCheckboxEl = document.querySelector('.surface-cutting-loss [type="checkbox"]')
  const cuttingLossLabelEl = document.querySelector('.surface-cutting-loss label')
  if (quantityInputEl && surfaceInputEl && cuttingLossCheckboxEl && cuttingLossLabelEl) {
    const baseSurface = parseFloat(surfaceInputEl.getAttribute('data-surface'))
    const baseMultiplier = 1.0
    let cuttingLoss = false
    const cuttingLossMultiplier = baseMultiplier + parseFloat(cuttingLossCheckboxEl.value)

    // compute initial values
    computeSurfaceValues(surfaceInputEl, cuttingLoss, cuttingLossMultiplier)
    computeQuantityValuesFromSurface(quantityInputEl, surfaceInputEl, baseSurface)

    // prevent submitting form when pressing "Enter", instead just blur input
    quantityInputEl.addEventListener('keypress', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault()
        quantityInputEl.blur()
      }
    })

    surfaceInputEl.addEventListener('keypress', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault()
        surfaceInputEl.blur()
      }
    })

    // update surface when quantity changes
    jQuery(quantityInputEl).on('change', () => {
      // disable cutting loss when quantity changes
      if (cuttingLoss) {
        cuttingLossCheckboxEl.checked = false
        cuttingLoss = false
        updateCuttingLossLabel(cuttingLossLabelEl, cuttingLoss)
      }

      // reflect value changes
      computeQuantityValuesFromBaseSurface(quantityInputEl, baseSurface, cuttingLoss, cuttingLossMultiplier)
      updateSurfaceInputValue(surfaceInputEl, quantityInputEl, baseSurface, cuttingLoss, cuttingLossMultiplier, true)
    })

    // update quantity when surface changes
    surfaceInputEl.addEventListener('change', () => {
      // disable cutting loss when surface changes
      if (cuttingLoss) {
        cuttingLossCheckboxEl.checked = false
        cuttingLoss = false
        updateCuttingLossLabel(cuttingLossLabelEl, cuttingLoss)
      }

      // reflect value changes
      computeSurfaceValues(surfaceInputEl, cuttingLoss, cuttingLossMultiplier)
      updateQuantityInputValue(quantityInputEl, surfaceInputEl, baseSurface, cuttingLoss, cuttingLossMultiplier, true)
    })

    // toggle "Apply cutting loss" multiplier
    cuttingLossCheckboxEl.addEventListener('click', () => {
      cuttingLoss = cuttingLossCheckboxEl.checked
      updateCuttingLossLabel(cuttingLossLabelEl, cuttingLoss)

      updateSurfaceInputValue(surfaceInputEl, quantityInputEl, baseSurface, cuttingLoss, cuttingLossMultiplier)
      updateQuantityInputValue(quantityInputEl, surfaceInputEl, baseSurface, cuttingLoss, cuttingLossMultiplier)
    })
  }
})

function updateCuttingLossLabel(labelEl, cuttingLoss) {
  labelEl.innerText = labelEl.getAttribute(getLabelAttributeName(cuttingLoss))
}

function getLabelAttributeName(cuttingLoss = false) {
  return cuttingLoss ? 'data-checked-label' : 'data-unchecked-label'
}

function getAttributeName(cuttingLoss = false) {
  return cuttingLoss ? 'data-cutting-loss-value' : 'data-base-value'
}

function getAttributeValue(el, cuttingLoss = false) {
  return el.getAttribute(getAttributeName(cuttingLoss))
}

function setElementDataValues(el, baseValue, cuttingLossValue) {
  el.setAttribute(getAttributeName(), baseValue)
  el.setAttribute(getAttributeName(true), cuttingLossValue)
}

function computeSurfaceValuesFromQuantity(surfaceInputEl, quantityInputEl, baseSurface, cuttingLossMultiplier) {
  const baseValue = getAttributeValue(quantityInputEl) * baseSurface
  const cuttingLossValue = baseValue * cuttingLossMultiplier
  setElementDataValues(surfaceInputEl, baseValue, cuttingLossValue)
}

function computeSurfaceValues(surfaceInputEl, cuttingLoss, cuttingLossMultiplier) {
  const currentValue = surfaceInputEl.value
  const baseValue = cuttingLoss ? currentValue / cuttingLossMultiplier : currentValue
  const cuttingLossValue = cuttingLoss ? currentValue : currentValue * cuttingLossMultiplier
  setElementDataValues(surfaceInputEl, baseValue, cuttingLossValue)
}

function updateSurfaceInputValue(surfaceInputEl, quantityInputEl, baseSurface, cuttingLoss, cuttingLossMultiplier, computeValues = false) {
  if (computeValues) {
    computeSurfaceValuesFromQuantity(surfaceInputEl, quantityInputEl, baseSurface, cuttingLossMultiplier)
  }

  const fractionDigits = String(baseSurface).split('.').pop().length
  surfaceInputEl.value = Number(parseFloat(getAttributeValue(surfaceInputEl, cuttingLoss)).toFixed(fractionDigits))
}

function computeQuantityValuesFromBaseSurface(quantityInputEl, baseSurface, cuttingLoss, cuttingLossMultiplier) {
  const currentValue = quantityInputEl.value
  const baseValue = cuttingLoss ? Math.ceil(currentValue * baseSurface / baseSurface) : currentValue
  const cuttingLossValue = cuttingLoss ? currentValue : Math.ceil(currentValue * baseSurface * cuttingLossMultiplier / baseSurface)
  setElementDataValues(quantityInputEl, baseValue, cuttingLossValue)
}

function computeQuantityValuesFromSurface(quantityInputEl, surfaceInputEl, baseSurface) {
  const baseValue = Math.ceil(getAttributeValue(surfaceInputEl) / baseSurface)
  const cuttingLossValue = Math.ceil(getAttributeValue(surfaceInputEl, true) / baseSurface)
  setElementDataValues(quantityInputEl, baseValue, cuttingLossValue)
}

function updateQuantityInputValue(quantityInputEl, surfaceInputEl, baseSurface, cuttingLoss, cuttingLossMultiplier, computeValues = false) {
  if (computeValues) {
    computeQuantityValuesFromSurface(quantityInputEl, surfaceInputEl, baseSurface)
  }

  quantityInputEl.value = getAttributeValue(quantityInputEl, cuttingLoss)
}
